import { Link } from "react-router-dom";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";

const GIUNTA = [
  { nome: "Massimo BERTONI", assoc: "Federazione Moda Italia Roma" },
  { nome: "Angelo DE AMICIS", assoc: "50ePiu Enasco" },
  { nome: "Pierpaolo DONATI", assoc: "Federpreziosi Roma" },
  { nome: "Anna Rita FIORONI", assoc: "Professioni Roma" },
  { nome: "Eugenio MICCONE", assoc: "Giovani Imprenditori Roma" },
  { nome: "Ilaria MILANA", assoc: "ALI Roma" },
  { nome: "Sergio PAOLANTONI", assoc: "FIPE Roma" },
  { nome: "Valter PAPETTI", assoc: "FIVA Roma" },
  { nome: "Simona PETROZZI", assoc: "Terziario Donna Roma" },
  { nome: "Maurizio PEZZETTA", assoc: "FIMAA Roma" },
  { nome: "Riccardo POMPEI", assoc: "FEDAGRO Mercati Roma" },
  { nome: "Camillo RICCI", assoc: "Federservizi" },
  { nome: "Giuseppe ROSCIOLI", assoc: "Federalberghi Roma" },
  { nome: "Fabrizio RUSSO", assoc: "Centro Storico" },
  { nome: "Luca STEVANATO", assoc: "Confederazione Sport" },
  { nome: "Valeria STRAPPINI", assoc: "Ascom Confcommercio Roma Litorale Sud" },
];

const VICEPRESIDENTI = [
  { nome: "Ilaria MILANA", delega: "Sviluppare identità associativa e 80 anni" },
  { nome: "Sergio PAOLANTONI", delega: "Sviluppo progetti per il lavoro" },
  { nome: "Maurizio PEZZETTA", delega: "Vicepresidente Vicario - Progetti sviluppo associativo" },
  { nome: "Camillo RICCI", delega: "Sviluppo progetti comunicazione e innovazione" },
  { nome: "Giuseppe ROSCIOLI", delega: "Sviluppo progetti per il turismo" },
  { nome: "Valeria STRAPPINI", delega: "Sviluppo progetti crescita litorale" },
];

const REVISORI = { effettivi: ["Alexandru BUJIN", "Mauro PIETRINI", "Luca TASCIO"], supplenti: ["Gianluca CARLUCCI", "Alessandro LONDI"] };
const GARANZIA = ["Angelo DE AMICIS", "Elisa D'ARRIGO", "Monica MENICHELLI", "Michele PIZZULLO", "Enrico VOLPETTI"];

export default function OrganismiPage() {
  return (
    <main id="main-content" data-testid="organismi-page">
      <section className="bg-[var(--confcom-blue)] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <HeroBreadcrumb />
          <h1 className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Organismi</h1>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Presidente e Direttore */}
          <div className="grid md:grid-cols-2 gap-7 mb-16 max-w-5xl mx-auto">
            <div className="p-7 bg-[var(--confcom-bg-subtle)] rounded-2xl border border-[var(--confcom-border)]" data-testid="presidente">
              <img src="/foto-chevallard.png" alt="Pier Andrea Chevallard, Presidente di Confcommercio Roma" className="w-full h-72 object-cover object-top rounded-xl mb-4 shadow-md" />
              <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">Pier Andrea Chevallard</h2>
              <div className="text-sm text-[var(--confcom-blue)] font-semibold mb-3">Presidente</div>
              <div className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed space-y-3">
                <p>Nato a Torino il 24 maggio 1951, laureato in Scienze Politiche presso l'Università degli Studi di Torino.</p>
                <p>Dal 2009 Amministratore Delegato di Tinexta Spa, dal 2015 anche Direttore Generale. Presidente di Confcommercio Roma dal 2023. Vice Presidente di Confcommercio Imprese per l'Italia da luglio 2024 con delega all'Innovazione e multicanalità.</p>
                <p>Da ottobre 2020 Componente del Consiglio e della Giunta della Camera di Commercio di Roma. Precedentemente Segretario Generale della Camera di Commercio di Milano (2001-2014), Presidente Accademia Teatro alla Scala.</p>
              </div>
            </div>
            <div className="p-7 bg-[var(--confcom-bg-subtle)] rounded-2xl border border-[var(--confcom-border)]" data-testid="direttore">
              <img src="/foto-guasco.png" alt="Romolo Guasco, Direttore di Confcommercio Roma" className="w-full h-72 object-cover object-top rounded-xl mb-4 shadow-md" />
              <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">Romolo Guasco</h2>
              <div className="text-sm text-[var(--confcom-blue)] font-semibold mb-3">Direttore</div>
              <div className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed space-y-3">
                <p>Nato a Roma il 9 ottobre 1958, laureato in Giurisprudenza nel 1983. Entra in Confcommercio nella Direzione Turismo.</p>
                <p>1995: Assessore al Turismo, Cultura, Sport e Spettacolo della Regione Lazio. Si occupa del sistema ospitalita per il Giubileo 2000.</p>
                <p>2010-2018: Direttore Centrale della Rete Associativa di Confcommercio Imprese per l'Italia. Dal 1 agosto 2020 Direttore di Confcommercio Roma.</p>
              </div>
            </div>
          </div>

          {/* Giunta */}
          <div className="mb-16">
            <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Giunta</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-3">
              {GIUNTA.map((m) => (
                <div key={m.nome} className="py-3 border-b border-[var(--confcom-border)] last:border-0">
                  <div className="text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">{m.nome}</div>
                  <div className="text-xs text-[var(--confcom-text-muted)] mt-0.5">{m.assoc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Vicepresidenti */}
          <div className="mb-16">
            <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Vicepresidenti Giunta</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
              {VICEPRESIDENTI.map((v) => (
                <div key={v.nome} className="py-3">
                  <div className="text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">{v.nome}</div>
                  <div className="text-xs text-[var(--confcom-blue)] mt-0.5 font-medium">{v.delega}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Revisori e Garanzia — affiancati, lista pulita */}
          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Collegio Revisori dei Conti</h2>
              <h4 className="text-xs font-bold uppercase tracking-wider text-[var(--confcom-text-muted)] mb-3">Effettivi</h4>
              <ul className="space-y-2 mb-6">
                {REVISORI.effettivi.map((n) => (
                  <li key={n} className="flex items-center gap-3 text-sm font-medium text-[var(--confcom-text-primary)]">
                    <span className="w-1.5 h-1.5 bg-[var(--confcom-blue)] rounded-full shrink-0" />
                    {n}
                  </li>
                ))}
              </ul>
              <h4 className="text-xs font-bold uppercase tracking-wider text-[var(--confcom-text-muted)] mb-3">Supplenti</h4>
              <ul className="space-y-2">
                {REVISORI.supplenti.map((n) => (
                  <li key={n} className="flex items-center gap-3 text-sm text-[var(--confcom-text-secondary)]">
                    <span className="w-1.5 h-1.5 bg-[var(--confcom-text-muted)] rounded-full shrink-0" />
                    {n}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Commissione di Garanzia</h2>
              <ul className="space-y-2">
                {GARANZIA.map((n) => (
                  <li key={n} className="flex items-center gap-3 text-sm font-medium text-[var(--confcom-text-primary)]">
                    <span className="w-1.5 h-1.5 bg-[var(--confcom-blue)] rounded-full shrink-0" />
                    {n}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
